import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { gispertSection1 } from '../utils/gispertContent1';
import { gispertSection1En } from '../utils/gispertContent1En';
import { getRelatedSectionsForGispert } from '../utils/relatedSections';
import RelatedSections from './RelatedSections';
import ContentGate from './ContentGate';

const Gispert1 = () => {
  const { t, i18n } = useTranslation();
  const content = i18n.language === 'en' ? gispertSection1En : gispertSection1;
  const [isUnlocked, setIsUnlocked] = useState(false);

  useEffect(() => {
    if (localStorage.getItem('spain_project_unlocked') === 'true') {
      setIsUnlocked(true);
    }
  }, []);


  return (
    <div className='TesisPage TesisPage--gispert'>
      <aside className='TesisPage-rail'>
        <RelatedSections items={getRelatedSectionsForGispert('/Gispert1')} />
      </aside>
      <h1 className='TesisPageTitle'>{t('gispert1.title')}</h1>
      <h2 className='TesisPageSubtitle'>{t('gispert1.subtitle')}</h2>
      <article className='TesisPageContent'>
        {isUnlocked ? (
          <>
            {content.map((p, i) => <p key={i}>{p}</p>)}
          </>
        ) : (
          <>
            {content.slice(0, 7).map((p, i) => <p key={i}>{p}</p>)}
            <ContentGate onUnlocked={() => setIsUnlocked(true)} />
          </>
        )}
      </article>
    </div>
  );
};

export default Gispert1;
